import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';

const DeleteGridItemModal = ({
	isOpen,
	title,
	description,
	details,
	onCancel,
	onConfirm,
	isDeleting,
}) => (
	<div>
		<Modal
			isOpen={isOpen}
			toggle={onCancel}
			size='sm'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop='static'
			centered={true}
		>
			<ModalHeader className='modal-title' />
			<ModalBody className='text-center p-3'>
				<lord-icon
					src='https://cdn.lordicon.com/tdrtiskw.json'
					trigger='loop'
					colors='primary:#f06548,secondary:#405189'
					style={{ width: '90px', height: '90px' }}
				></lord-icon>
				<div className='mt-2'>
					<h3 className='mb-3'>{title}</h3>
					<p className='text-muted mb-4'>{description}</p>
					{details}
					<div className='hstack gap-2 justify-content-center'>
						<Button
							className='btn-danger btn-label'
							onClick={onCancel}
							disabled={isDeleting}
						>
							<i className='ri-close-line label-icon'></i> Cancelar
						</Button>
						<button
							className='btn btn-label btn-primary'
							onClick={onConfirm}
							disabled={isDeleting}
						>
							{isDeleting ? (
								<i className='label-icon'><Spinner size='sm' /></i>
							) : (
								<i className='ri-check-double-line label-icon'></i>
							)}{' '}
							Confirmar
						</button>
					</div>
				</div>
			</ModalBody>
		</Modal>
	</div>
);

export default DeleteGridItemModal;
